<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <div
      v-if="pgLoading"
      class="owl-theme owl-carousel home-main-carousel moving-waves"
    ></div>
    <!-- moving-waves carousel -->
    <carousel
      class="home-main-carousel"
      v-if="!pgLoading && items"
      :rtl="$i18n.locale == 'ar' ? true : false"
      :autoplay="true"
      :items="1"
      :nav="true"
      :dots="false"
      :navText="[
        `<i class='fa fa-angle-right'></i>`,
        `<i class='fa fa-angle-left'></i>`,
      ]"
    >
      <a
        v-for="(item, idx) in items"
        :key="idx"
        aria-label="slider"
        class="Home-slider-slide item single-slider pos-rel d-flex align-items-center"
        style="border-radius: 0; margin-inline: 0"
        :style="
          'background-image: url(' +
          (item.image ? item.image.url : '/assets/img/logo/min-logo.png') +
          ')'
        "
        :href="item.call_to_action"
      >
        <a
          v-if="item.button && item.call_to_action"
          :aria-label="item.call_to_action"
          class="home-slider-donate-btn theme_btn theme_btn_bg wow fadeInUp2 animated"
          :href="item.call_to_action"
        >
          {{ item.button }}
          <span class="hideInMobile"
            ><i class="fas fa-hand-holding-seedling"></i
          ></span>
        </a>
        <!-- 
                        data-wow-delay=".3s"
                        data-toggle="modal"
                        data-target="#donation-modal" 
                    -->
      </a>
    </carousel>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel2";

export default {
  name: "Sliders",
  components: {
    carousel,
  },
  data() {
    return {
      //
      items: [],
      pgLoading: false,
      locale: "ar",
      refs: "sliders",
    };
  },
  mounted() {
  },
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/" + this.refs,
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          paginate: 100,
        },
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.items = res.data.rows;
        })
        .catch(() => {})
        .finally(() => {});
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
